// Mercadorias.jsx
import React from 'react';
import { Box } from '@mui/material';
import MercadoriasLayout from './Mercadoria/MercadoriasLayout'; // ajuste o caminho conforme necessário

const Mercadorias = () => {
    return (
        <Box>
            <MercadoriasLayout />
        </Box>
    );
};

export default Mercadorias;
